module.exports = __webpack_public_path__ + "static/img/image004.3205ead.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/news7/image004.png
// module id = AwYz
// module chunks = 1